import EmptyStateCommon from './containers/emptyStateCommon'

export {default as EmptyStateCommonLayout} from './components/emptyStateCommonLayout'

export default EmptyStateCommon
